import {
  AccordionContent,
  AccordionHeading,
} from '@moonpig/launchpad-components'
import React, { FC } from 'react'
import { ImportedHTML } from '@moonpig/web-shared-products'
import { useCoreLocaleText } from '@moonpig/web-core-locale-text'
import { useProductContext } from '../../../../contexts/product'
import { AccordionSections } from '../types'

export const ProductDescriptionModule: FC = () => {
  const localiseText = useCoreLocaleText()

  const [{ product }] = useProductContext()
  return (
    <AccordionContent
      heading={
        <AccordionHeading level="h2">
          {localiseText('common.product_details')}
        </AccordionHeading>
      }
      value={AccordionSections.Description}
    >
      <ImportedHTML html={product.description} />
    </AccordionContent>
  )
}
